import { pipe } from 'core/utilities';

import { getScrollProps, setBarPositionProps, InitialAttrs } from './Scrollbar.d';

function getPositionPercentage({
  offsetWidth,
  scrollPosition,
  scrollWidth,
  ...rest
}: getScrollProps) {
  return {
    positionPercentage: (scrollPosition / (scrollWidth - offsetWidth)) * 100,
    ...rest,
  };
}

function setBarPosition({
  handleBarWidth,
  positionPercentage,
  scrollBarWidth,
}: setBarPositionProps) {
  const isPositionMinorThanBarWidth =
    (positionPercentage / 100) * handleBarWidth <= handleBarWidth - scrollBarWidth;

  if (isPositionMinorThanBarWidth) {
    return `${(positionPercentage / 100) * handleBarWidth}px`;
  }

  return `${handleBarWidth - scrollBarWidth}px`;
}

export function getBarPosition(attrs: InitialAttrs) {
  return pipe([getPositionPercentage, setBarPosition])(attrs);
}
